import { z } from 'zod';
import { UseSchema, ZitadelRoleEnum, ZitadelRoleTuple } from '../../common';

const roleValues = Object.values(ZitadelRoleEnum) as ZitadelRoleTuple;

export const customerGrantCreateDtoSchema = z.object({
  roles: z.array(z.enum(roleValues)).describe('The roles to assign to the user'),
});

@UseSchema(customerGrantCreateDtoSchema)
export class CustomerGrantCreateDto {}
export interface CustomerGrantCreateDto extends z.infer<typeof customerGrantCreateDtoSchema> {}
